import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useQuoteTranslation = (locale: string) => {
  const { i18n } = useTranslation();
  const [t, setT] = useState(() => i18n.getFixedT(locale));

  useEffect(() => {
    let obsolete = false;

    i18n.loadLanguages(locale).then(() => {
      if (!obsolete) {
        setT(() => i18n.getFixedT(locale));
      }
    });

    return () => {
      obsolete = true;
    };
  }, [i18n, locale]);

  return t;
};
